import { useState, useCallback } from "react";
import type { ParcoursGroup } from "../types/groupTypes";

const MAX_GROUPS = 3;

interface UseParcoursGroupsReturn {
  groups: ParcoursGroup[];
  createGroup: (name: string, parcoursIds: number[]) => boolean;
  deleteGroup: (groupId: string) => void;
  canCreateGroup: boolean;
}

export const useParcoursGroups = (): UseParcoursGroupsReturn => {
  const [groups, setGroups] = useState<ParcoursGroup[]>([]);

  const canCreateGroup = groups.length < MAX_GROUPS;

  const createGroup = useCallback(
    (name: string, parcoursIds: number[]): boolean => {
      if (groups.length >= MAX_GROUPS) return false;
      if (parcoursIds.length === 0) return false;

      const newGroup: ParcoursGroup = {
        id: crypto.randomUUID(),
        name,
        parcoursIds,
        createdAt: new Date(),
      };
      setGroups((prev) => [...prev, newGroup]);
      return true;
    },
    [groups.length],
  );

  const deleteGroup = useCallback((groupId: string) => {
    setGroups((prev) => prev.filter((g) => g.id !== groupId));
  }, []);

  return {
    groups,
    createGroup,
    deleteGroup,
    canCreateGroup,
  };
};
